import { removeTrailingSlashes } from '../../../../../utils/locationUtils';

export const getElementIdFromPathName = (path) => {
  return path && path.length > 1 && removeTrailingSlashes(path.substring(1));
};

export const getElementIdFromHash = (path) =>
  path.split('#').slice(1).join('#');

export const hasHashPart = (path) => {
  if (typeof path === 'string') {
    return path.includes('#');
  }
  return typeof path === 'object' && typeof path.hash === 'string';
};
